/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AwsServiceCdnPresignRequest } from "../models/AwsServiceCdnPresignRequest";
import type { AwsServiceCdnPresignResponseApiRespoonse } from "../models/AwsServiceCdnPresignResponseApiRespoonse";
import type { AwsServiceDownloadFilePresignRequest } from "../models/AwsServiceDownloadFilePresignRequest";
import type { AwsServiceDownloadFilePresignResponseApiRespoonse } from "../models/AwsServiceDownloadFilePresignResponseApiRespoonse";
import type { AwsServiceUploadFilePresignRequest } from "../models/AwsServiceUploadFilePresignRequest";
import type { AwsServiceUploadFilePresignResponseApiRespoonse } from "../models/AwsServiceUploadFilePresignResponseApiRespoonse";
import type { AwsServiceUploadPresignRequest } from "../models/AwsServiceUploadPresignRequest";
import type { AwsServiceUploadPresignResponseApiRespoonse } from "../models/AwsServiceUploadPresignResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class AwsService {
  /**
   * 投稿の新規登録
   * @param requestBody
   * @returns AwsServiceCdnPresignResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static awsCdnPresign(
    requestBody: AwsServiceCdnPresignRequest
  ): CancelablePromise<AwsServiceCdnPresignResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/aws/cdn-presign",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Presign url upload to bucket image
   * @param requestBody
   * @returns AwsServiceUploadPresignResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static awsUploadPresign(
    requestBody: AwsServiceUploadPresignRequest
  ): CancelablePromise<AwsServiceUploadPresignResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/aws/upload-presign",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Presign url upload to bucket file
   * @param requestBody
   * @returns AwsServiceUploadFilePresignResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static awsUploadFilePresign(
    requestBody: AwsServiceUploadFilePresignRequest
  ): CancelablePromise<AwsServiceUploadFilePresignResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/aws/upload-file-presign",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Presign url upload to bucket file
   * @param requestBody
   * @returns AwsServiceDownloadFilePresignResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static awsDownloadFilePresign(
    requestBody: AwsServiceDownloadFilePresignRequest
  ): CancelablePromise<AwsServiceDownloadFilePresignResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/aws/download-file-presign",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
